import { useEDTHistory } from './historyAtoms';
import { useQueryClient } from '@tanstack/react-query';
import { EDT_KEY } from '@teetsh/app/src/queries/edt/useEDTs';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { EDTEvent, EmploiDuTemps } from '@teetsh/app/src/types/edt';
import useDeleteEDTEvents from '@teetsh/app/src/queries/edt/useDeleteEDTEvents';
import useCreateEDTEvent from '@teetsh/app/src/queries/edt/useCreateEDTEvent';
import { useUpdateEdtSeance } from '@teetsh/app/src/queries/edt/useUpdateEdtSeance';

export default function useUndoEDT(edtId: string) {
  const { schoolyear, school } = useSchoolSchoolyear();
  const { past, setPast, future, setFuture } = useEDTHistory(edtId);
  const updateEdtSeance = useUpdateEdtSeance(edtId, true);
  const removeEDTEvents = useDeleteEDTEvents(edtId, true);
  const createEDTEvents = useCreateEDTEvent(edtId, true);
  const queryClient = useQueryClient();

  return () => {
    const edt = queryClient.getQueryData<EmploiDuTemps>([
      schoolyear.id,
      school.id,
      EDT_KEY,
      edtId,
    ]);
    const previousEvents = (past.pop() as EDTEvent[]) || [];
    setPast(past);
    if (edt) {
      setFuture([edt.events, ...future]);
    }
    const pastIds = previousEvents.map(evt => evt.id);
    const currentEvents = edt?.events || [];
    const currentIds = currentEvents.map(evt => evt.id);
    const eventsToDelete = (edt?.events || []).filter(
      evt => !pastIds.includes(evt.id),
    );
    const eventsToCreate = previousEvents.filter(
      evt => !currentIds.includes(evt.id),
    );
    const eventsToUpdatePromises = previousEvents
      .filter(evt => currentIds.includes(evt.id))
      .map(ev => updateEdtSeance(ev));
    return Promise.all([
      removeEDTEvents(eventsToDelete.map(evt => evt.id)),
      ...eventsToUpdatePromises,
      ...eventsToCreate.map(evt => createEDTEvents(evt)),
    ]);
  };
}
